import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { CButton } from '../components';
import { Alert, Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import validator from 'validator'


export function handleAuthError(errorCode) {
    switch (errorCode) {
        
        case "auth/wrong-password":
          return "Eposta adresiniz veya şifreniz doğru değil.";

        case "auth/invalid-password":
          return "Uygun bir eposta adresi giriniz.";
    
        case "auth/invalid-email":
          return "Uygun bir şifre giriniz.";

        case "auth/too-many-requests":
          return "Çok fazla deneme yaptınız.";

        case "auth/network-request-failed":
            return "Ağ hatası."

        case "auth/user-not-found":
            return "Kullanıcı bulunamadı."

        case "auth/email-already-in-use":
            return "Bu eposta adresi zaten kullanımda."
    
        default:
          return "Bir hata oluştu.";
      }
}

export default function LoginPage() {

    let auth = getAuth()
    const navigate = useNavigate()

    const [alert, setAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    onAuthStateChanged(auth, (user) => {
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            const uid = user.uid;
            navigate("/")
            // ...
        } else {
            // User is signed out

        }
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        if (!validator.isEmail(data.get('email'))) {
            setAlertMessage("Uygun bir eposta adresi giriniz.")
            setAlert(true)

        } else if (!data.get('password')) {
            setAlertMessage("Şifrenizi girmediniz.")
            setAlert(true)

        } else {
            const auth = getAuth();
            signInWithEmailAndPassword(auth, data.get('email'), data.get('password'))
                .then((userCredential) => {
                    // Signed in 
                    const user = userCredential.user;
                    // ...
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;

                    console.log(error.code)
    
                    setAlertMessage(handleAuthError(error.code))
                    setAlert(true)
                });
        }

       
    };

    return (
        <Container component="main" maxWidth="xs">
            <Collapse in={alert}>
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAlert(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {alertMessage}
                </Alert>
            </Collapse>
            <CssBaseline />
            <Box
                 marginBottom={"15px"}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
               
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    
                    <TextField
                        className='TextField'
                        margin="dense"
                        required
                        fullWidth
                        id="email"
                        label="Eposta Adresiniz"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        margin="dense"
                        required
                        fullWidth
                        name="password"
                        label="Şifreniz"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    <CButton
                    type="submit">
                        Giriş Yap
                    </CButton>
                    
                    <Grid marginTop={'15px'} container>
                        <Link style={{all: "unset"}} href="/kayit" variant="body2">
                                Kayıt olmak istiyorum.
                        </Link>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
}